import { bootstrap } from '@avensia/excite/client';
import { SiteLayout } from 'nordicnest/src/app/site-layout';
import '../component-registry';
import { setupRaygunErrorLogging } from 'webapp/raygun-browser-logging';
import { AppProviders } from 'nordicnest/app-providers';
import { theme } from '../app/shared/theme';
import { setLinkUrlDecorator } from '@avensia/excite/link';
import { linkUrlDecorator } from 'webapp/link-url-decorator';
import { registerChildlessProviders } from '@avensia/excite/progressive-hydration';
import '../app/global.css';

setupRaygunErrorLogging();

setLinkUrlDecorator(linkUrlDecorator);

registerChildlessProviders(AppProviders, () => ({
  theme,
}));

bootstrap(
  <AppProviders theme={theme}>
    <SiteLayout />
  </AppProviders>,
);
